import { CSSProperties } from "react";

export const inputStyleBase: CSSProperties = {
  width: 160,
};
